/**
 * Configuração global de CNPJ alfanumérico.
 * Setada pelo useCnpjRules (hook) e lida pelas funções utilitárias.
 * Permite que maskCNPJ, unmaskCNPJ, formatCNPJOrCPF respeitem a feature flag
 * sem precisar de hook em cada chamada.
 */
let _allowAlphanumeric = false;

export const cnpjConfig = {
  get allowAlphanumeric() {
    return _allowAlphanumeric;
  },
  set allowAlphanumeric(value: boolean) {
    _allowAlphanumeric = value;
  },
};
